import React, { useState } from 'react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/9nlk2ja0_24438fb0-71b6-4404-9a9b-cbef19dd1d13.jpeg',
      title: 'Outdoor Seating with Dramatic Lighting',
      category: 'Event Setup',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/sdu89xz4_6b3c464b-ce16-4c50-bd6b-53d9a4854858.jpeg',
      title: 'Luxury Mandap with Crystal Canopy',
      category: 'Wedding',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/loryhxht_1d93168c-9a9c-4b89-9023-029665c936fb.jpeg',
      title: 'Sunset Ceremony Setup',
      category: 'Wedding',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/87kdr6bc_83171989-9012-481f-b062-8c58873cb51f.jpeg',
      title: 'Floral Photobooth Decoration',
      category: 'Decoration',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/8c9pqpoh_4c839cb1-0c36-47da-96e6-37301c309d31.jpeg',
      title: 'Dramatic Stage with Professional Lighting',
      category: 'Wedding',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/blu7pxhk_bab35fe0-8548-4b81-9fb3-0569ce84f624.jpeg',
      title: 'Outdoor Mandap Setup',
      category: 'Wedding',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/nh8b81hx_f9098ec6-ef9d-4e46-919b-0ea58c474a7c.jpeg',
      title: 'Wedding Baraat Ceremony',
      category: 'Wedding',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/55feew7c_9d238921-ef87-45e3-a9c0-bbe83467ed5b.jpeg',
      title: 'Vintage Car Decoration',
      category: 'Decoration',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/oqx2ljq8_fbba0a65-6805-4f0e-8ef8-3171abef56c4.jpeg',
      title: 'Stage Setup with Lighting',
      category: 'Event Setup',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_made-in-heaven/artifacts/u6cwlur4_9b471af2-805d-4b36-8f19-40bc08944a22.jpeg',
      title: 'Traditional Mandap Design',
      category: 'Wedding',
    },
  ];

  return (
    <section id="gallery" className="py-20 md:py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-amber-600 font-semibold text-lg tracking-wide uppercase">
            Our Portfolio
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Events We've Created
          </h2>
          <p className="text-lg text-gray-600">
            Take a look at some of the stunning events we've brought to life for our clients.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer aspect-[4/3]"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="text-sm text-amber-400 mb-2">{image.category}</div>
                  <h3 className="text-xl font-semibold">{image.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal for enlarged image */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-5xl max-h-[90vh]">
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="max-w-full max-h-[90vh] object-contain rounded-lg"
              />
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 bg-white/20 backdrop-blur-md text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
              >
                ✕
              </button>
              <div className="absolute bottom-4 left-4 right-4 bg-black/50 backdrop-blur-md rounded-lg p-4 text-white">
                <div className="text-sm text-amber-400 mb-1">{selectedImage.category}</div>
                <h3 className="text-xl font-semibold">{selectedImage.title}</h3>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
